import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/core/services/user/user.service';
import { Address, SalePoint, ShippingMethodType } from 'src/app/interfaces/salePoints.interface';
import { User } from 'src/app/interfaces/user.interface';
declare var $: $;
@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.scss'],
})
export class AddressListComponent implements OnInit {
  @Input() addressList: Address[] = [];
  @Input() salePoints: SalePoint[] = [];
  @Input() user!: User;

  /**To block whit request */
  clicRequest: boolean = false;

  /** Saved address selected */
  addressSelect: Address | null = null;

  public sortedAddressList: Address[] = [];

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    public router: Router,
  ) { }

  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges) {
    this.getMainAddress();
  }

  /**
   * Change Address when the user selected an address different to address main
   */
  async changeAddress(): Promise<void> {
    if (this.clicRequest) return;

    const selected = this.addressSelect;
    if (!selected) {
      this.toastr.error('Selecciona una dirección.');
      return;
    }
    const list = Array.isArray(this.addressList) ? this.addressList : [];
    const position = list.indexOf(selected);
    if (position < 0) {
      this.toastr.error('La dirección seleccionada no existe en la lista.');
      return;
    }

    this.markAsPrimary(list, selected);
    const salePoint = this.findSalePointByAddress(selected);

    try {
      this.clicRequest = true;

      if (salePoint) {
        this.hidePopover();
        await this.updateUserAddressWithCovarege(list, salePoint, selected);
      } else {
        this.showPopover();
        await this.updateUserAddressWithoutCovarege(list, salePoint);
      }

    } finally {
      this.clicRequest = false;
    }
    for (let address of this.addressList) {
      address.principal = false;
    }
  }

  private markAsPrimary(list: Address[], selected: Address): void {
    list.forEach(a => (a.principal = false));
    selected.principal = true;
  }

  private findSalePointByAddress(address: Address): SalePoint | null {
    const inv = (address as any)?.inventario;
    if (!inv) return null;

    const sp = (this.salePoints ?? []).find(s => s?.bodega === inv);
    return sp ?? null;
  }

  /**
   * Update address information in firebase
   * @param addressList Address aray
   * @param salePoint Address sale point
   * @param addressSelect Address select by user
   */
  async updateUserAddressWithCovarege(addressList, salePoint, addressSelect): Promise<void> {
    const address = this.buildLegacyDireccion(addressSelect);
    this.applySalePointToUser(salePoint);
    this.user.direccion = address;
    this.user.direcciones = addressList;
    this.user.tipoEntrega = "Domicilio";

    $('#popover')?.popover('hide');

    // Update user
    await this.persistAndFinish(addressSelect, true);
  }

  async updateUserAddressWithoutCovarege(addressList, addressSelect): Promise<void> {
    const address = this.buildLegacyDireccion(addressSelect);
    this.user.direccion = address;
    this.user.direcciones = addressList;
    // Update user
    await this.persistAndFinish(addressSelect, true);
  }

  private async persistAndFinish(selected: Address, shouldReload: boolean): Promise<void> {
    await this.userService.updateUserData(this.user);

    this.setCoverageLocalStorage(selected);
    this.emitGlobalShipping(selected);

    this.showSuccessToast();

    this.router.navigate(['/']);
    this.closeModal();

    if (shouldReload) {
      setTimeout(() => window.location.reload(), 0);
    }
  }

  /**
   * Get the main user address
   */
  getMainAddress() {
    if (this.addressList !== undefined) {
      let address = this.addressList.filter(
        (address) => address.principal == true
      );
      if (address.length !== 0) {
        this.addressSelect = address[0];
      } else {
        this.addressSelect = this.addressList[0];
      }
      let index = this.addressList.indexOf(this.addressSelect);
      this.addressList.splice(index, 1);
      this.addressList.unshift(this.addressSelect);
    }
  }

  /**
   * Function to update user after verify coverage
   * @param addressSelect
   */
  updateUserAfterVerify(addressSelect) {
    // Update user
    this.userService
      .updateUserData(this.user)
      .then(() => {
        addressSelect.cobertura ? localStorage.setItem('cobertura', 'SI') : localStorage.setItem('cobertura', 'NO');
        this.userService.onSendGlobalShippingMethod({
          type: ShippingMethodType.SHIPPING,
          address: addressSelect
        });
        this.toastr.success('Tu dirección ha sido cambiada con éxito.');

        this.router.navigate(['/']);
        $('#closeAddressListModal')?.click();
      })
      .catch((error) => {
        this.toastr.error('No hemos podido cambiar tu dirección.');
        console.log(`Error adding address: ${error}`);
      });
  }

  private buildLegacyDireccion(addr: Partial<any> | null | undefined): string {
    if (!addr) return '';

    if (addr.formatted && typeof addr.formatted === 'string') {
      return addr.formatted.trim();
    }

    const nom = (addr.nomenclatura ?? '').trim();
    const uno = (addr.numeroUno ?? '').trim();
    const dos = (addr.numeroDos ?? '').trim();
    const tres = (addr.numeroTres ?? '').trim();
    const indicaciones = (addr.indicaciones ?? '').trim();

    const nomIncluyeNumero =
      uno && nom.toLowerCase().includes(uno.toLowerCase());

    const calle = nomIncluyeNumero ? nom : `${nom} ${uno}`.trim();

    let direccion = calle;

    if (dos || tres) {
      direccion += ` # ${dos}`;
      if (tres) direccion += `-${tres}`;
    }

    if (indicaciones) {
      direccion += ` -- ${indicaciones}`;
    }

    return direccion
      .replace(/\s+/g, ' ')
      .replace(/#\s*-/, '# ')
      .trim();
  }


  formatAddress(address: any): string {
    if (!address) return '';

    const formatted = this.buildLegacyDireccion(address);

    if (!formatted || formatted === '#' || formatted.includes('null')) {
      return '';
    }

    return formatted;
  }

  private applySalePointToUser(salePoint: SalePoint): void {
    this.user.puntoDeVentaBarrio = salePoint.barrio;
    this.user.puntoDeVentaBodega = salePoint.bodega;
    this.user.puntoDeVentaCiudad = salePoint.nombreMunicipio;
    this.user.puntoDeVentaCodMun = salePoint.codigoMunicipio;
    this.user.puntoDeVentaDepto = salePoint.codigoDepartamento;
    this.user.puntoDeVentaId = salePoint.id;
    this.user.puntoDeVentaNombre = salePoint.nombre;
    this.user.puntoDeVentaTpv = salePoint.tpv;
    this.user.puntoDeVentaWhatsapp = salePoint.whatsapp;
  }

  private setCoverageLocalStorage(address: Address): void {
    const value = (address as any)?.cobertura ? 'SI' : 'NO';
    localStorage.setItem('cobertura', value);
  }

  private emitGlobalShipping(address: Address): void {
    this.userService.onSendGlobalShippingMethod({
      type: ShippingMethodType.SHIPPING,
      address,
    });
  }

  public openModal(event): void {
    $(event)?.click();
    this.closeAddressListModal();
  }
  private showSuccessToast(): void {
    const positionClass = window.innerWidth < 490 ? 'toast-top-center' : 'toast-top-right';
    this.toastr.success('Tu dirección ha sido cambiada con éxito.', undefined, { positionClass });
  }

  private hidePopover(): void {
    $('#popover')?.popover('hide');
  }

  private showPopover(): void {
    $('#popover')?.popover('show');
  }
  public closeAddressListModal(): void {
    $('#closeAddressListModal')?.click();
  }

  private closeModal(): void {
    $('#closeAddressListModal')?.click();
  }
}
